export enum WarningTypes {
  NoBlank = 'W1',
  SafeDesigns = 'W2',
  HasSleeves = 'W4',
  Unprintable = 'W5',
}
